// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: fixed;
  margin-bottom: 2em;
}
`, "",{"version":3,"sources":["webpack://./src/LAYOUTS/index.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".navbar {\n  position: fixed;\n  margin-bottom: 2em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
